import script from "./RichTextEditor.vue?vue&type=script&lang=ts&setup=true"
export * from "./RichTextEditor.vue?vue&type=script&lang=ts&setup=true"

import "./RichTextEditor.vue?vue&type=style&index=0&id=2fdb3008&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/webapp/webapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2fdb3008"]])

export default __exports__